import { render } from "./CourtList.vue?vue&type=template&id=be7db2ac"
import script from "./CourtList.vue?vue&type=script&lang=js"
export * from "./CourtList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__